(function () {
  function formatMoney(value, symbol) {
    return `${symbol}${Number(value).toFixed(2)}`;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function toNumber(value, fallback = 0) {
    const num = parseFloat(value);
    return Number.isFinite(num) ? num : fallback;
  }

  function initPriceSlider(priceRangeEl) {
    if (!priceRangeEl || priceRangeEl.dataset.jsSliderInit === 'true') return;

    const minInput = priceRangeEl.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = priceRangeEl.querySelector('input[name="filter.v.price.lte"]');
    if (!minInput || !maxInput) return;

    const currencyEl = priceRangeEl.querySelector('.field-currency');
    const currencySymbol = currencyEl ? currencyEl.textContent.trim() : '$';

    // Always use 0 as slider minimum
    const min = 0;

    // Always use the largest available data-max as absolute slider maximum
    const absoluteMax = Math.max(
      toNumber(minInput.dataset.max, 0),
      toNumber(maxInput.dataset.max, 0)
    );

    if (!absoluteMax) return;

    const max = absoluteMax;

    // Current selected values come from the actual field values
    let from = toNumber(minInput.value, min);
    let to = toNumber(maxInput.value, max);

    // If max value is empty, default to absolute max
    if (!maxInput.value || isNaN(to)) to = max;
    if (!minInput.value || isNaN(from)) from = min;

    from = clamp(from, min, max);
    to = clamp(to, min, max);

    if (from > to) from = to;

    priceRangeEl.querySelectorAll('.field').forEach((el) => {
      el.classList.add('js-price-slider-hidden');
    });

    if (currencyEl) currencyEl.classList.add('js-price-slider-hidden');

    const oldSlider = priceRangeEl.querySelector('.js-price-slider-box');
    if (oldSlider) oldSlider.remove();

    const sliderBox = document.createElement('div');
    sliderBox.className = 'js-price-slider-box';
    sliderBox.innerHTML = `
      <div class="js-price-slider">
        <div class="js-price-slider__track"></div>
        <div class="js-price-slider__progress"></div>
        <div class="js-price-slider__handle js-price-slider__handle--min" tabindex="0" role="slider" aria-label="Minimum price"></div>
        <div class="js-price-slider__handle js-price-slider__handle--max" tabindex="0" role="slider" aria-label="Maximum price"></div>
      </div>
      <div class="js-price-slider__values">
        <span class="js-price-slider-value-min"></span>
        <span class="js-price-slider-value-max"></span>
      </div>
    `;

    priceRangeEl.appendChild(sliderBox);

    const slider = sliderBox.querySelector('.js-price-slider');
    const progress = sliderBox.querySelector('.js-price-slider__progress');
    const minHandle = sliderBox.querySelector('.js-price-slider__handle--min');
    const maxHandle = sliderBox.querySelector('.js-price-slider__handle--max');
    const minLabel = sliderBox.querySelector('.js-price-slider-value-min');
    const maxLabel = sliderBox.querySelector('.js-price-slider-value-max');

    function percent(value) {
      if (max === min) return 0;
      return ((value - min) / (max - min)) * 100;
    }

    function render() {
      const left = percent(from);
      const right = percent(to);

      minHandle.style.left = `${left}%`;
      maxHandle.style.left = `${right}%`;

      progress.style.left = `${left}%`;
      progress.style.width = `${right - left}%`;

      minLabel.textContent = formatMoney(from, currencySymbol);
      maxLabel.textContent = formatMoney(to, currencySymbol);

      minInput.value = from.toFixed(2);
      maxInput.value = to.toFixed(2);
    }

    let submitTimer;

    function submitForm() {
      const form = priceRangeEl.closest('form');
      if (!form) return;

      clearTimeout(submitTimer);
      submitTimer = setTimeout(() => {
        form.dispatchEvent(new Event('input', { bubbles: true }));
      }, 250);
    }

    function updateFromPointer(clientX, handleType) {
      const rect = slider.getBoundingClientRect();
      const ratio = clamp((clientX - rect.left) / rect.width, 0, 1);
      const rawValue = Math.round(min + ratio * (max - min));

      if (handleType === 'min') {
        from = Math.min(rawValue, to);
      } else {
        to = Math.max(rawValue, from);
      }

      render();
    }

    function dragHandle(handle, type) {
      const onPointerMove = (e) => {
        updateFromPointer(e.clientX, type);
      };

      const onPointerUp = () => {
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        submitForm();
      };

      handle.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
      });
    }

    dragHandle(minHandle, 'min');
    dragHandle(maxHandle, 'max');

    render();
    priceRangeEl.dataset.jsSliderInit = 'true';
  }

  function initAllPriceSliders() {
    document.querySelectorAll('price-range.facets__price').forEach((el) => {
      if (
        el.querySelector('input[name="filter.v.price.gte"]') &&
        el.querySelector('input[name="filter.v.price.lte"]')
      ) {
        initPriceSlider(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAllPriceSliders);
  document.addEventListener('shopify:section:load', initAllPriceSliders);

  const observer = new MutationObserver(() => {
    initAllPriceSliders();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
